module.exports = __webpack_public_path__ + "img/h-dialogImg2.38a5e5b4.png";